import { render, staticRenderFns } from "./TransportationsComponent.vue?vue&type=template&id=c515ecd4&scoped=true"
import script from "./TransportationsComponent.vue?vue&type=script&lang=js"
export * from "./TransportationsComponent.vue?vue&type=script&lang=js"
import style0 from "./TransportationsComponent.vue?vue&type=style&index=0&id=c515ecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c515ecd4",
  null
  
)

export default component.exports